module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relatorios-basico h-full"
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "content loading"
  }, [_c('div', {
    staticClass: "cload"
  }, [_c('import-progress', {
    attrs: {
      "percent": _vm.loadPercent
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading && !_vm.graphLoaded),
      expression: "!isLoading && !graphLoaded"
    }],
    staticClass: "content loading",
    style: ({
      'justify-content': 'center'
    })
  }, [_c('div', {
    staticClass: "cload no-select"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showMenuBtn) ? _c('div', {
    staticClass: "m-b-sm grid-container"
  }, _vm._l((_vm.menuRelatorios), function(contrato) {
    return (_vm.ACL.check(contrato.acl, _vm.currentUser.id)) ? _c('button', {
      class: ("btn " + (contrato.color || 'btn-default') + " btn-lg grid-item"),
      attrs: {
        "value": contrato.value
      },
      on: {
        "click": function($event) {
          return _vm.tipoRelatorio($event, contrato.value)
        }
      }
    }, [_c('i', {
      class: ((contrato.icon) + " block")
    }), _vm._v("\n            " + _vm._s(contrato.label) + "\n          ")]) : _vm._e()
  }), 0) : _c('div', {
    key: "2",
    staticClass: "m-b-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("Relatórios " + _vm._s(_vm.labelsReport))])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.gerar.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "rel-type row"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo),
      expression: "tipo"
    }],
    staticStyle: {
      "width": "100%",
      "height": "50px",
      "font-size": "20px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.MENU), function(itens, key) {
    return _c('optgroup', {
      attrs: {
        "label": key
      }
    }, _vm._l((itens), function(item) {
      return _c('option', {
        attrs: {
          "disabled": item.disabled
        },
        domProps: {
          "value": item.value
        }
      }, [_vm._v(_vm._s(item.label))])
    }), 0)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "filters row m-t"
  }, [(_vm.GRUPOS_RELATORIO.checarGrupo('habilitarFiltroData', _vm.tipo)) ? _c('div', [_c('div', {
    staticClass: "text-black"
  }, [_vm._v("Período:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data1),
      expression: "data1"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    attrs: {
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.data1)
    },
    on: {
      "change": _vm.modifyForm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data2),
      expression: "data2"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    staticClass: "m-l",
    domProps: {
      "value": (_vm.data2)
    },
    on: {
      "change": _vm.modifyForm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data2 = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.GRUPOS_RELATORIO.checarGrupo('habilitarFiltroPatio', _vm.tipo)) ? _c('div', [_c('div', {
    staticClass: "text-black"
  }, [_vm._v("Pátio:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPatio),
      expression: "selectedPatio"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Não selecione caso não queira uma filtragem por pátio"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPatio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticStyle: {
      "font-weight": "bold"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos os pátios")]), _vm._v(" "), _vm._l((_vm.patiosComputed), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.value
      }
    }, [_vm._v(_vm._s(cat.label))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.GRUPOS_RELATORIO.checarGrupo('leilao', _vm.tipo)) ? _c('div', {
    staticClass: "autocomplete-input"
  }, [_c('div', {
    staticClass: "text-black"
  }, [_vm._v("Leilão:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.filteredListaLeiloes,
      "placeholder": "Selecione um leilão"
    },
    model: {
      value: (_vm.selectedLeilao),
      callback: function($$v) {
        _vm.selectedLeilao = $$v
      },
      expression: "selectedLeilao"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row m-t"
  }, [_c('button', {
    staticClass: "m-l btn btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_c('b', [_vm._v("Gerar "), _c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "m-l btn btn-dark",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMenuBtn = !_vm.showMenuBtn
      }
    }
  }, [_c('b', [_vm._v("Fechar")])])])])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header hidden-print row"
  }, [_c('div', {
    staticClass: "title col-sm-11"
  }, [_c('span', [_vm._v("Relatórios Gerenciais")])]), _vm._v(" "), _c('div', {
    staticClass: "back col-sm-1"
  }, [_c('strong', {
    staticClass: "label bg-info",
    staticStyle: {
      "font-size": "14px",
      "cursor": "pointer"
    },
    attrs: {
      "onclick": "window.history.back()"
    }
  }, [_vm._v("Voltar")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8be34e06","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/relatorios-gerenciais/Main.vue
// module id = 1994
// module chunks = 18